<template>
  <div class="card">
    <div class="card-body">
      <!-- Nav tabs -->
      <!-- <div class="row mb-3">
        <div class="col-sm-3">
          <multiselect
            v-model="filters.status"
            label="name"
            track-by="value"
            :options="filters.statusOptions"
            :searchable="false"
            :close-on-select="false"
            :show-labels="false"
            :allow-empty="false"
            placeholder="Կարգավիճակ"
          />
        </div>
      </div> -->
      <!-- Tab panes -->
      <div class="row">
        <div class="col-12 tenders-list">
            <v-server-table
              ref="vtable"
              :url="`${proxyUrl}contract/getRequestsByProvider`"
              :options="options"
              :columns="columns"
              @loaded="({data}) => onLoaded(data)"
              @row-click="({row}) => {row.organize.status !== 'finished' && $modal.show('suggestion-modal', {...row, resetComponent})}"
            >
              <div slot="index" class="d-flex justify-content-center" slot-scope="{row, index}">
                  {{ index }}
              </div>
              <div slot="total_leftover" class="d-flex justify-content-center" slot-scope="{row}">
                  {{ parseFloat(getContractLeftover(row).toFixed(2)) }}դր.
              </div>
              <div slot="delete" class="d-flex justify-content-center">
                <i class="mdi mdi-delete text-danger" style="font-size: 30px; cursor: pointer;"></i>
              </div>
              <div slot="actions" class="d-flex justify-content-center" slot-scope="{row}">
                <div class="row">
                  <div class="col-6">
                    <button
                      @click="signContract(row)"
                      type="button" 
                      class="btn btn-sm btn-success">
                        Կնքել
                    </button>
                  </div>
                  <div class="col-6">
                    <button
                      @click="cancelContract(row)"
                      type="button" 
                      class="btn btn-sm btn-danger">
                        Չեղարկել
                    </button>
                  </div>
                </div>
              </div>
            </v-server-table>
        </div>
        <specification-modal />
        <!-- end col -->
      </div>
    </div>
  </div>
</template>

<script>
  import SpecificationModal from '@/components/modals/SpecificationModal'

  export default {
    name: 'contracts',
    data() {
      return {
        proxyUrl: process.env.VUE_APP_API_URL,
        columns: ['index', 'code', 'client.name', 'price', 'actions'],
        options: {
          requestAdapter(data) {
            return {
              limit: data.limit ? data.limit : 5,
              page: data.page,
              query: data.query,
            }
          },
          responseAdapter({data}) {
            return { 
              data: data.data, 
              count: data.count
            }
          },
          requestFunction(data) {
            return this.$client.get(this.url, {params: data})
            .catch(function (e) {this.dispatch('error', e)})
          },
          params:{ 
            component: this
          },
          sortable: [],
          // sortable: ['cpvs_count', 'code', 'type', 'customer', 'category', 'status', 'end_date'],
          columnsDropdown: false,
          pagination: { chunk: 1 },
          filterByColumn: false,
          dateColumns:['create_date','end_date'],
          dateFormat: "YYYY-mm-dd",
          headings: {
            index: 'Հ/Հ',
            code: 'Պայմանագրի ծածկագիր',
            'client.name': 'Պատվիրատուի անվանում',
            sign_date: 'Կնքման ամսաթիվ',
            price: 'Ընդհանուր արժեք',
            total_leftover: 'Ընդհանուր մնացորդ ըստ պատվերների',
            actions: '',
          },
          filterable: false,
          texts: {
            count: 'Ցուցադրված է {from}֊ից {to}֊ը ընդհանուր {count} տողից|{count} տող|',
            first: 'Առաջին',
            last: 'Վերջին',
            filter: '',
            filterPlaceholder: 'Փնտրել',
            limit: '',
            page: 'Page:',
            noResults: 'Համընկնում չի գտնվել',
            noRequest: 'խնդրում ենք ընտրել առնվազն մեկ ֆիլտեր տվյալները ներբեռնելու համար',
            filterBy: 'փնտրել ըստ {column}',
            loading: 'Բեռնվում է...',
            defaultOption: 'ընտրել {column}',
            columns: 'Ընտրել դաշտերը',
          },
        },
        filters: {
          status: { name: 'Բոլորը', value: 'all' },
          statusOptions: [
            { name: 'Բոլորը', value: 'all' },
            { name: 'Ակտիվ առաջարկներ', value: 'active' },
            { name: 'Ավարտված առաջարկներ', value: 'finished' },
          ],
        }
      }
    },
    components: { SpecificationModal},
    computed: {
      locale() {
        return this.$store.getters['user/locale']
      },
      me() {
        return this.$store.getters['user/me']
      },
    },
    mounted() {},
    methods: {
      consoleLog(e){
        console.log(e)
      },
      signContract(contract) {
        this.$client.put(`contract/${contract.id}`, {is_sign: 1})
        this.resetComponent()
      },
      cancelContract(contract) {
        console.log(contract.id)
        contract.lots.forEach((lot) => {
          this.$client.delete(`participant-row/${lot.row.offers[0].id}`)
          this.$client.delete(`contract-lots/${lot.id}`)
          this.$client.put(`organize-row/${lot.row.id}`, {won_lot_id: null, winner_user_id: null})
        })
        this.$client.delete(`contract/${contract.id}`)
        this.$client.put(`organize/oneperson/${contract.organize.id}`, {create_contract: 0, winner_user_id: null, winner_user_price: null})
        this.resetComponent()
      },
      onLoaded({data}){
        const contractId = this.$route.params.id
        if(contractId){
          const contract = data.find(item => item.id === +contractId)
          this.$modal.show('order-modal', {contract: contract})
        }
      },
      getContractLeftover(row){
        const { price, lots } = row
        var leftover = 0;
        lots.forEach((lot) => {
          leftover += lot.supplied * lot.price_unit
        })
        return price - leftover;
      },
      async resetComponent() {
        await this.$refs.vtable.refresh()
      },
    },
  }
</script>